var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBurger(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "14px",
    viewBox: "0 0 16 14",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 10") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "header",
    transform: "translate(-20.000000, -22.000000)",
    fill: "#B1C3C8"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-10",
    transform: "translate(20.000000, 22.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 16,
    height: 2,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy",
    x: 0,
    y: 6,
    width: 16,
    height: 2,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-3",
    x: 0,
    y: 12,
    width: 16,
    height: 2,
    rx: 1
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBurger);
export default __webpack_public_path__ + "static/media/burger.ace342d94bdc42ee388699b883272cf5.svg";
export { ForwardRef as ReactComponent };